import type React from 'react';
import { useEffect, useState } from 'react';

import ReactMarkdown from 'react-markdown';
import { rehypeDom } from 'rehype-dom';
import rehypeExternalLinks from 'rehype-external-links';
import rehypeSanitize from 'rehype-sanitize';

interface TFMarkdownTextProps {
	text: string;
	className?: string;
}

export const TFMarkdownText: React.FC<TFMarkdownTextProps> = ({ text, className }) => {
	// react-markdown 10 dropped both `linkTarget` and `className`. The target
	// moves to rehype-external-links -- the same plugin and options TFHTMLText
	// below already uses -- and the class moves to a wrapper, as it does there.
	return (
		<div className={className}>
			<ReactMarkdown rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}>{text}</ReactMarkdown>
		</div>
	);
};

export const TFHTMLText: React.FC<TFMarkdownTextProps> = ({ text, className }) => {
	const [cleanHTML, setCleanHTML] = useState('');

	useEffect(() => {
		const process = async () => {
			const processedHtml = await rehypeDom()
				.use(rehypeSanitize)
				.use(rehypeExternalLinks, { target: '_blank' })
				.process(text);

			setCleanHTML(String(processedHtml));
		};

		process();
	}, [text]);

	// biome-ignore lint/security/noDangerouslySetInnerHtml: cleanHTML is the output of rehypeSanitize above, not raw input
	return <div className={className} dangerouslySetInnerHTML={{ __html: cleanHTML }}></div>;
};
